<template>
  <div class="no-content">
    <div class="no-content__context">
      <img src="/img/no-content.svg" alt="">
      <p>{{ text }}</p>
      <div class="button-group">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: false,
      default: 'Sorry, No content available',
    },
  },
}
</script>
